import React from 'react';
import PropTypes from 'prop-types';
import Cards from 'react-credit-cards-2';
import './card.scss';

const Card = (props) => (
  <Cards {...props} />
);

Card.propTypes = {

};

export default Card;
